document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-mobile-menu]');
  const overlay = document.querySelector('[data-menu-overlay]');
  const menuButtons = document.querySelectorAll('[data-menu-toggle]');
  const setMenu = (open) => {
    if (!menu || !overlay) return;
    menu.hidden = !open;
    overlay.hidden = !open;
    document.body.classList.toggle('menu-open', open);
    menuButtons.forEach(btn => btn.setAttribute('aria-expanded', open ? 'true' : 'false'));
  };
  menuButtons.forEach(btn => btn.addEventListener('click', () => setMenu(menu ? menu.hidden : true)));
  if (overlay) overlay.addEventListener('click', () => setMenu(false));

  const searchBtn = document.querySelector('[data-search-toggle]');
  const searchDrawer = document.querySelector('[data-search-drawer]');
  if (searchBtn && searchDrawer) {
    searchBtn.addEventListener('click', () => {
      searchDrawer.hidden = !searchDrawer.hidden;
      if (!searchDrawer.hidden) searchDrawer.querySelector('input')?.focus();
    });
  }

  document.querySelectorAll('[data-slider]').forEach(slider => {
    const slides = [...slider.querySelectorAll('.hero-slide')];
    const dots = [...slider.querySelectorAll('[data-slide-dot]')];
    let current = 0;
    const show = (index) => {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((s,i) => s.classList.toggle('is-active', i === current));
      dots.forEach((d,i) => d.classList.toggle('is-active', i === current));
    };
    slider.querySelector('[data-slide-next]')?.addEventListener('click', () => show(current + 1));
    slider.querySelector('[data-slide-prev]')?.addEventListener('click', () => show(current - 1));
    dots.forEach((d,i) => d.addEventListener('click', () => show(i)));
    if (slides.length > 1) setInterval(() => show(current + 1), 6500);
  });

  document.querySelectorAll('[data-product-thumb]').forEach(btn => {
    btn.addEventListener('click', () => {
      const main = document.querySelector('#ProductMainImage');
      if (main) main.src = btn.dataset.productThumb;
    });
  });

  document.querySelectorAll('[data-sort-select]').forEach(select => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });

  // Collection-card AJAX add to cart, so customers can add several products without leaving the collection page.
  document.querySelectorAll('[data-card-add-form]').forEach(form => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type=submit]');
      const status = form.querySelector('[data-card-add-status]');
      const original = button.dataset.addText || 'Add to cart';
      button.disabled = true;
      button.textContent = 'Adding…';
      if (status) status.textContent = '';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: [{id: Number(form.elements.id.value), quantity: 1}]})
        });
        if (!response.ok) throw new Error('Could not add item');
        const cartResponse = await fetch('/cart.js', {headers: {'Accept': 'application/json'}});
        const cart = await cartResponse.json();
        document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
        button.textContent = 'Added ✓';
        if (status) status.textContent = 'Added to cart';
        setTimeout(() => {
          button.textContent = original;
          button.disabled = false;
          if (status) status.textContent = '';
        }, 1400);
      } catch (error) {
        button.textContent = original;
        button.disabled = false;
        if (status) status.textContent = 'Please try again';
      }
    });
  });

  // Counts down to 11:59:59 PM in the visitor's local time, then starts a fresh daily cycle.
  const timerEls = document.querySelectorAll('[data-daily-sale-timer]');
  if (timerEls.length) {
    const updateSaleTimer = () => {
      const now = new Date();
      const end = new Date(now);
      end.setHours(23, 59, 59, 999);
      let seconds = Math.max(0, Math.floor((end - now) / 1000));
      const h = String(Math.floor(seconds / 3600)).padStart(2, '0');
      seconds %= 3600;
      const m = String(Math.floor(seconds / 60)).padStart(2, '0');
      const sec = String(seconds % 60).padStart(2, '0');
      timerEls.forEach(el => el.textContent = `${h}:${m}:${sec}`);
    };
    updateSaleTimer();
    setInterval(updateSaleTimer, 1000);
  }

});